import ConfigFile from '../../datasets/config_file';
import assetExpLoanShortnameDataset from '../../datasets/asset_exp_loan__shortname_dataset';
import {monthlyLoanAmt} from './loanAmtCalc_function';
import { calcNbrMonthsBtwnDates } from '../CommonUse/nbr_months_btwn_dates_calc';
import { calcInflationAmt } from '../CommonUse/calc_inflation_amt';
import determineLoanIntRateChange from '../../components/game-views/objects/determine_loan_int_rate_chg';

export const createTableItem = ( shortName, description, startDate, amount, gameDate, 
        calcInflationAmtSw, loanIntRate ) => {
    
    let assetExpLoanType = assetExpLoanShortnameDataset;
    let itemType = "";
    let itemName = "";
    let newTableObj = {};
    let itemDesc = "";
    let loanTerm = "";
    let chargeCreditCard = false;
    if (loanIntRate === undefined){
        loanIntRate = 0;
    }
    const assetExpLoanObj = assetExpLoanType.find(elem => elem.shortName === shortName);
    if (assetExpLoanObj ){
        itemType = assetExpLoanObj.type;
        itemName = assetExpLoanObj.fullName;
        itemDesc = assetExpLoanObj.desc;
        if (assetExpLoanObj.chargeCreditCard ){
            chargeCreditCard = assetExpLoanObj.chargeCreditCard;
        };
    }
    
    if (itemDesc === "" || (description && description !== "")){
        itemDesc = description
    }

    let itemAmount = amount;
    if (calcInflationAmtSw && calcInflationAmtSw === true){
        let nbrMonths = calcNbrMonthsBtwnDates(startDate, gameDate);
        let nbrYears = (nbrMonths/12).toFixed(2);
        itemAmount = calcInflationAmt(amount, nbrYears);
    }

    let loanMonths = 0;
    let intRate = 0;
    let baseRate = 0;
    if (itemType === "loan"){
        switch (shortName){
            case "mortgage":
                loanTerm = +(ConfigFile.homeItems.mortgageLoanTerm); 
                loanMonths = loanTerm * 12;
                if (loanIntRate === 0){
                    baseRate = +(ConfigFile.homeItems.mortgageInterest);
                    intRate = determineLoanIntRateChange(baseRate);
                }else{
                    intRate = loanIntRate;
                }
                break;
            case "car":
                loanTerm = +(ConfigFile.carItems.carLoanTerm) 
                loanMonths = loanTerm * 12;
                if (loanIntRate === 0){
                    baseRate = +(ConfigFile.carItems.carInterest);
                    intRate = determineLoanIntRateChange(baseRate);
                }else{
                    intRate = loanIntRate;
                }
                break;
            case "college":
                loanTerm = +(ConfigFile.collegeItems.collegeLoanTerm)
                loanMonths = loanTerm * 12;
                intRate = +(ConfigFile.collegeItems.collegeInterest);
                break;
            default: 
                break;
        }
    }

    switch (itemType){
         case "asset":
            newTableObj = {assetItem: itemName, assetDesc: itemDesc, assetAmt: itemAmount,
                assetStartDate: startDate, assetNbrMonths: "-1"}
            break;
         case "expense":
            newTableObj = {expItem: itemName, expDesc: itemDesc, expAmount: itemAmount,
                expStartDate: startDate, expNbrMonths: "-1", chargeCreditCard: chargeCreditCard};
            break;
         case "loan":
            // when item type is "loan", the amount is the total loan amount (not a monthly amount)
            let loanAmt = monthlyLoanAmt(itemAmount, intRate, loanTerm);
            newTableObj = {loanType: itemName, loanDesc: itemDesc, loanAmt: loanAmt,
                loanStartDate: startDate, loanNbrMonths: loanMonths, loanTotAmt: itemAmount, 
                loanIntRate: intRate, loanTerm: loanTerm};
            break;
        default:
            break;
    }

    return newTableObj;
      
 }

